module.exports = __webpack_public_path__ + "img/EducationalScheduleUsers.6d27f4b1.svg";